// Centralised image library — all AI-generated luxury imagery
// for Fundle (SOH) editorial design system.

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/e7b7c648a5a38df87fb84d709c673539a7743620b3a717edcb02e85299d6d876.png",
  mumbai: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/01b834727bb50f34d8dc95c897ea6f31eb89b1fa115373ed5ccc904b270c8d4f.png",
  delhi: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/e0e37d5fa3f845936849f7838830a45742ab4c9e2811ec2f24cb467e0d3f4fe8.png",
  bengaluru: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/4041d062a7a426b7b5010d09e7718d9b18ed53af0580098f315e9864f0ff7319.png",
  backlitPillar: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/1e79d898a945cbd2c34900ecf31ddeb1d218baee2b1409e1ddcffb0e98ed3be7.png",
  escalator: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/cc6e7f172e08a447051719cca7cc3552ae2da208331bed25a2079229b4d46edf.png",
  hangingBanner: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/b4c4821905693d1220d2aa138427e0c8eb36d28b330f418b09d72e02117d708e.png",
  dropdownBanner: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/19ff61a99edce9fa4647a1cc2ff99f34d4fe40c930b6eeee8783f7eb1555df02.png",
  exteriorLightbox: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/16547f0e43f981c3e6fbb111f290acce47ea6e4ccfc6f182f0e705864ed352d7.png",
  foodCourt: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/c58804361903ac35fcff4774f81847d4d2002593450148d0a0b3a4e836469401.png",
  popupBooth: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/ade325cdce5484861d2f42904c66ed29a1123e2732dce7bd41d3e11bf5565d89.png",
  highStreet: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/b11d7cb33172aa543073c99571593dcac5d17ae22cad0bf2904f411dface1c4c.png",
  aiPlannerMag: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/58bad243bd25329ccebade30c455899d8485fb5971549f3e07eca75a338759fb.png",
  kiosk: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/98cebd85ded1e2f8c4c95a404a3215c91c8bc37d220bdaad76a1d0f01e73a145.png",
  luxuryGradient: "https://static.prod-images.emergentagent.com/jobs/6679a907-7ec9-400b-a523-c64779620124/images/f663f79bf19f231c406976b5bb6b2c51071472f6165f21e924e311e1a4770373.png",
  stockMall1: "https://images.unsplash.com/photo-1533481405265-e9ce0c044abb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  stockMall2: "https://images.pexels.com/photos/8337785/pexels-photo-8337785.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

// City → image map (fallback to stock if no AI gen)
export const CITY_IMAGES = {
  "Mumbai": IMG.mumbai,
  "Delhi": IMG.delhi,
  "Bengaluru": IMG.bengaluru,
  "Chennai": IMG.foodCourt,
  "Hyderabad": IMG.backlitPillar,
  "Kochi": IMG.hangingBanner,
  "Pune": IMG.escalator,
  "Kolkata": IMG.exteriorLightbox,
  "Calicut": IMG.popupBooth,
  "Chandigarh": IMG.dropdownBanner,
  "Lucknow": IMG.kiosk,
  "Coimbatore": IMG.stockMall1,
  "Thiruvanathapuram": IMG.stockMall2,
  "Ahmedabad": IMG.highStreet,
  "Noida": IMG.delhi,
  "Gurugram": IMG.delhi,
  "Surat": IMG.highStreet,
};

// Format → image map
export const FORMAT_IMAGES = {
  "Backlit": IMG.backlitPillar,
  "Pillar Branding": IMG.backlitPillar,
  "Pillar Display": IMG.backlitPillar,
  "Facade": IMG.exteriorLightbox,
  "Atrium Space": IMG.hangingBanner,
  "Atrium Branding": IMG.hangingBanner,
  "LED Screen": IMG.escalator,
  "Escalator Branding": IMG.escalator,
  "Standee": IMG.popupBooth,
  "Lift Branding": IMG.escalator,
  "Hoarding": IMG.highStreet,
  "Dropdown": IMG.dropdownBanner,
  "Frontlit": IMG.exteriorLightbox,
  "Kiosk": IMG.kiosk,
  "Sampling Booth": IMG.popupBooth,
  "Barricade Branding": IMG.popupBooth,
  "Food Court": IMG.foodCourt,
  "Flex": IMG.highStreet,
  "Vinyl": IMG.backlitPillar,
  "Hologram Branding": IMG.escalator,
  "Light Branding": IMG.backlitPillar,
  "Signage": IMG.exteriorLightbox,
  "Ambient-lit": IMG.backlitPillar,
};

export function imageForCity(city) {
  return CITY_IMAGES[city] || IMG.stockMall1;
}

export function imageForFormat(fmt) {
  if (!fmt) return IMG.backlitPillar;
  // try exact match, then partial
  if (FORMAT_IMAGES[fmt]) return FORMAT_IMAGES[fmt];
  const lower = fmt.toLowerCase();
  for (const key of Object.keys(FORMAT_IMAGES)) {
    if (lower.includes(key.toLowerCase())) return FORMAT_IMAGES[key];
  }
  return IMG.backlitPillar;
}

// Subtle brand-logo wall — real Indian/India-available brand names (wordmark only,
// no logos, to stay clear of trademark issues while signalling category leaders).
export const TRUSTED_BY = [
  "TATA", "MAHINDRA", "JIO", "AIRTEL", "HDFC", "ICICI",
  "LAKMÉ", "NYKAA", "ASIAN PAINTS", "AMUL", "FLIPKART", "MYNTRA",
  "SWIGGY", "ZOMATO", "PAYTM", "BYJU'S", "BMW INDIA", "MERCEDES-BENZ INDIA",
];

// Featured campaigns — real Indian/India-available brands × Indian cities
// (editorial brief copy, no real campaign claim — illustrative only)
export const FEATURED_CAMPAIGNS = [
  { brand: "Tata Motors · Punch.ev", city: "Mumbai", caption: "Atrium reveal that became a test-drive funnel", image: IMG.hangingBanner, format: "Atrium Domination" },
  { brand: "Lakmé", city: "Bengaluru", caption: "Backlit pillars at every floor — festive launch", image: IMG.backlitPillar, format: "Backlit Pillar Cluster" },
  { brand: "HDFC Bank · Millennia", city: "Hyderabad", caption: "Kiosks at HNI catchments — premium card sign-ups", image: IMG.kiosk, format: "Experiential Kiosk" },
  { brand: "JioHotstar · Originals", city: "Delhi", caption: "High-street takeover for series launch weekend", image: IMG.highStreet, format: "High-Street Hoarding" },
  { brand: "Nykaa Beauty Bar", city: "Kochi", caption: "Atrium drop-downs synced with sampling on-ground", image: IMG.dropdownBanner, format: "Atrium Dropdown" },
  { brand: "Swiggy Instamart", city: "Pune", caption: "Sampling activations that doubled trial uptake", image: IMG.popupBooth, format: "Sampling Activation" },
];
